import Route from '@ember/routing/route';

export default class EsIndexRoute extends Route {
  // This route inherits locale setup from parent 'es' route
  // No additional setup needed - parent route handles locale and SEO
}



